import { useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { latestArticles, mangaList } from '@/mocks/siteData';

const articleContents: Record<number, { sections: { heading: string; body: string }[]; fullContent: string }> = {
  1: {
    sections: [
      { heading: '一、禁漫天堂官方主站入口', body: '禁漫天堂官方主站是访问平台的首选方式，官方主域名提供了最稳定的访问体验。目前官方主站入口为 jmcomic1.me，经过优化的服务器架构和CDN加速，可以确保全国各地的用户都能流畅访问。建议用户优先使用官方主站入口，以获得最佳的使用体验。' },
      { heading: '二、禁漫天堂备用域名', body: '为了应对可能出现的网络波动和访问限制，禁漫天堂提供了多个备用域名。这些备用域名与主站内容完全同步，当主站访问缓慢或暂时不可用时，用户可以切换至备用域名继续阅读。目前可用的备用域名包括 jmcomic2.cc 等，均经过严格测试确保稳定性。' },
      { heading: '三、禁漫天堂官方镜像站点', body: '镜像站点是禁漫天堂在多个服务器上部署的完整副本，内容与主站实时同步更新。镜像站的优势在于分散访问压力，提供更快的响应速度。当前可用的镜像站点包括 18comic.vip 和 18comic.org，用户可根据自身网络环境选择最合适的镜像站进行访问。' },
      { heading: '四、CDN加速节点', body: '禁漫天堂部署了多个CDN加速节点，通过全球分布式网络将内容缓存到离用户最近的服务器上。这不仅大幅提升了访问速度，还有效降低了主站服务器的负载。当前可用的CDN加速节点包括 jmcomic1.art 等。' },
      { heading: '五、访问建议与注意事项', body: '建议用户收藏多个入口地址以备不时之需。同时推荐使用主流浏览器（Chrome、Edge、Firefox）进行访问，关闭不必要的浏览器插件以避免兼容性问题。如遇访问困难，可尝试清除浏览器缓存、切换DNS服务器（推荐使用114.114.114.114或8.8.8.8）等方法解决。' },
    ],
    fullContent: '',
  },
  2: {
    sections: [
      { heading: '一、检查网络连接', body: '首先确认您的网络连接是否正常。可以尝试访问其他网站来验证网络状态。如果其他网站也无法访问，请检查路由器、调制解调器或联系网络服务提供商。' },
      { heading: '二、DNS优化方案', body: 'DNS解析问题是导致网站打不开的常见原因之一。建议将DNS服务器更换为更稳定的公共DNS：首选114.114.114.114，备选8.8.8.8。修改方法：在系统网络设置中找到DNS配置选项，手动添加上述DNS地址即可。' },
      { heading: '三、浏览器缓存清理', body: '浏览器缓存的旧数据有时会导致页面加载异常。请按照以下步骤清理缓存：打开浏览器设置 → 隐私与安全 → 清除浏览数据 → 勾选"缓存的图片和文件" → 点击清除。清理后重启浏览器再尝试访问。' },
      { heading: '四、代理与VPN设置', body: '如果上述方法仍无法解决问题，可能是网络运营商对特定域名进行了限制。此时建议使用代理或VPN服务来绕过限制。推荐使用稳定性较高的VPN服务，连接后选择延迟较低的节点，然后重新尝试访问禁漫天堂。' },
      { heading: '五、使用禁漫天堂APP', body: '如果网页端始终无法正常访问，可以尝试下载禁漫天堂官方APP。APP内置了智能服务器切换功能，可以自动连接到最优服务器，大大提高了访问成功率。APP支持Android和iOS双平台。' },
    ],
    fullContent: '',
  },
  3: {
    sections: [
      { heading: '一、APP下载方式', body: '禁漫天堂官方APP支持Android和iOS双平台。Android用户可直接在官网下载APK安装包，iOS用户可通过TestFlight或官方企业签名渠道安装。下载前请确保手机已开启"允许安装未知来源应用"的选项（Android）。' },
      { heading: '二、注册与登录', body: '打开APP后，点击"注册"按钮创建新账号。输入邮箱地址并设置密码，完成邮箱验证后即可登录。已有账号的用户直接输入账号密码登录即可。APP支持记住密码功能，方便日常使用。' },
      { heading: '三、核心功能详解', body: 'APP提供完整的漫画阅读功能：书架管理可以将喜欢的漫画加入收藏；阅读历史自动记录阅读进度；离线下载功能支持将漫画缓存到本地，无网络时也能继续阅读；阅读设置支持多种翻页模式和背景颜色切换，满足不同阅读习惯。' },
      { heading: '四、VIP会员专属功能', body: 'VIP会员在APP上享有更多特权：去广告纯净阅读体验、1080P高清画质模式、提前解锁最新章节、专属VIP漫画库等。会员还享有优先客服通道，问题处理更高效。' },
      { heading: '五、常见问题排查', body: '如APP出现闪退或卡顿，建议先尝试清除APP缓存或重启手机。若下载的漫画无法打开，请检查手机存储空间是否充足。APP需要至少保留500MB的可用空间以确保正常运行。' },
    ],
    fullContent: '',
  },
  4: {
    sections: [
      { heading: '一、免费用户权益', body: '禁漫天堂免费用户可以阅读平台上的大部分漫画内容，每天享有一定数量的免费阅读章节。免费用户观看时会显示少量广告，画质为标准清晰度。免费用户的阅读进度和收藏列表同样会保存在云端。' },
      { heading: '二、VIP会员权益总览', body: '开通VIP会员后，您将享受以下专属权益：无广告纯净阅读、高清画质（最高1080P）、每日免费章节额度翻倍、专属VIP漫画库访问权限、新章节提前24小时解锁、离线下载数量无限制、优先客服支持等。' },
      { heading: '三、会员订阅方案', body: '禁漫天堂提供灵活的订阅方案：月度会员适合短期使用需求的用户；季度会员性价比更高，适合经常阅读的用户；年度会员是最实惠的选择，日均花费最低，适合忠实读者。所有方案均支持自动续费，可随时取消。' },
      { heading: '四、如何开通会员', body: '开通会员的步骤非常简单：登录账号后，点击页面右上角的"开通VIP"按钮，选择心仪的订阅方案，通过支付宝、微信支付或银行卡完成付款即可。开通成功后会员权益即时生效，无需等待。' },
    ],
    fullContent: '',
  },
};

export default function Article() {
  const { id } = useParams<{ id: string }>();
  const articleId = Number(id);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [articleId]);

  const article = useMemo(() => {
    return latestArticles.find((a) => a.id === articleId);
  }, [articleId]);

  const content = useMemo(() => {
    return articleContents[articleId];
  }, [articleId]);

  if (!article || !content) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6 py-20 text-center">
            <i className="ri-file-unknow-line text-6xl text-foreground-300 block mb-4"></i>
            <h1 className="text-xl font-heading text-foreground-950 mb-2">文章未找到</h1>
            <p className="text-foreground-500 mb-6">该文章不存在或已被移除</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-5 py-2.5 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    );
  }

  const siteUrl = `https://jmcomic.com/article/${articleId}`;

  return (
    <>
      <SEOHead
        title={`${article.title} - 禁漫天堂在线`}
        description={article.excerpt}
        keywords={`${article.category},禁漫天堂在线,禁漫天堂访问指南,禁漫天堂使用教程,成人漫画`}
        canonicalUrl={siteUrl}
        ogType="article"
        ogImage={article.image}
      />
      <SchemaOrg type="Article" data={{
        headline: article.title,
        description: article.excerpt,
        image: article.image,
        datePublished: article.date,
        author: { '@type': 'Organization', name: '禁漫天堂在线' },
        publisher: { '@type': 'Organization', name: '禁漫天堂在线' },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://jmcomic.com' },
          { '@type': 'ListItem', position: 2, name: '访问指南', item: 'https://jmcomic.com/' },
          { '@type': 'ListItem', position: 3, name: article.title, item: siteUrl },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <article className="max-w-3xl mx-auto px-4 md:px-6">
            <Breadcrumb items={[
              { label: '首页', path: '/' },
              { label: '访问指南', path: '/' },
              { label: article.title },
            ]} />

            <div className="mb-8">
              <div className="flex items-center gap-2 flex-wrap mb-3">
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs whitespace-nowrap">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap flex items-center gap-1">
                  <i className="ri-time-line text-xs"></i>
                  {article.readTime}
                </span>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
                {article.title}
              </h1>
              <p className="text-sm text-foreground-600 leading-relaxed">{article.excerpt}</p>
            </div>

            <div className="mb-8 rounded-lg overflow-hidden aspect-[16/9]">
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} - 禁漫天堂在线`}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="prose-sm max-w-none mb-12">
              {content.sections.map((section, idx) => (
                <section key={idx} className="mb-8">
                  <h2 className="text-lg font-heading text-foreground-950 mb-3">
                    {section.heading}
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {section.body}
                  </p>
                </section>
              ))}
            </div>

            <div className="border-t border-background-200 pt-6 mb-12">
              <h3 className="text-base font-heading text-foreground-950 mb-4">相关文章</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {latestArticles
                  .filter((a) => a.id !== articleId)
                  .slice(0, 2)
                  .map((related) => (
                    <Link
                      key={related.id}
                      to={`/article/${related.id}`}
                      className="group flex gap-3 p-3 rounded-lg border border-background-200/70 hover:bg-background-100 transition-colors"
                    >
                      <div className="w-20 h-14 rounded overflow-hidden flex-shrink-0">
                        <img
                          src={related.image}
                          alt={related.title}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2">
                          {related.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1 block whitespace-nowrap">{related.date}</span>
                      </div>
                    </Link>
                  ))}
              </div>
            </div>
          </article>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}